import withTimerSecondInterval from './withTimerSecondInterval';
export function calculateRemainingTime(endTimestamp) {
    const timestamp = Number(endTimestamp);
    if (isNaN(timestamp)) {
        return { finished: true, remaining: 0 };
    }
    let remaining = Math.floor((timestamp - Date.now()) / 1000);
    let finished = false;
    if (remaining < 0) {
        finished = true;
        remaining = 0;
    }
    return { finished, remaining };
}
export function convertSecondsToDisplayTime(remaining) {
    const sec = remaining % 60;
    const min = Math.floor(Number(remaining / 60) % 60);
    const minWithoutHrs = Math.floor(Number(remaining / 60));
    const hrsWithoutDay = Math.floor(Number(remaining / 3600));
    const hrs = hrsWithoutDay % 24;
    const day = Math.floor(Number(remaining / 86400));
    return { day, hrs, hrsWithoutDay, min, minWithoutHrs, sec };
}
export function padNumber(number) {
    const parsed = number.toString();
    if (parsed.length < 2)
        return `0${parsed}`;
    return parsed;
}
export default {
    calculateRemainingTime,
    convertSecondsToDisplayTime,
    padNumber,
    withTimerSecondInterval,
};
